import React, { FC, SVGAttributes } from 'react';

const GiftCard: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.5 10.3C1.5 7.3306 1.5 5.84485 2.42295 4.92295C3.34485 4 4.8306 4 7.8 4H16.2C19.1694 4 20.6551 4 21.577 4.92295C22.5 5.84485 22.5 7.3306 22.5 10.3V14.5C22.5 17.4694 22.5 18.9551 21.577 19.877C20.6551 20.8 19.1694 20.8 16.2 20.8H7.8C4.8306 20.8 3.34485 20.8 2.42295 19.877C1.5 18.9551 1.5 17.4694 1.5 14.5V10.3Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.5 12.5C22.5 12.5 8.91996 12.5 1.5 12.5M12 4V20.5M12.95 12.5C12.95 13.5078 13.3504 14.4744 14.063 15.187C14.7756 15.8996 15.7422 16.3 16.75 16.3M11.05 12.5C11.05 13.5078 10.6496 14.4744 9.93701 15.187C9.22437 15.8996 8.25782 16.3 7.25 16.3"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11.9999 10.6334C12.0005 9.94555 12.2307 9.27757 12.654 8.73545C13.0774 8.19333 13.6697 7.80811 14.3369 7.64091C15.8598 7.26091 17.2401 8.64031 16.8592 10.1641C16.692 10.8313 16.3068 11.4236 15.7646 11.847C15.2225 12.2704 14.5545 12.5006 13.8667 12.5011H11.9999M11.9999 10.6334V12.5011M11.9999 10.6334C11.9994 9.94555 11.7692 9.27757 11.3458 8.73545C10.9224 8.19333 10.3301 7.80811 9.66292 7.64091C8.14007 7.26091 6.75972 8.64031 7.14067 10.1641C7.30788 10.8313 7.6931 11.4236 8.23522 11.847C8.77734 12.2704 9.44532 12.5006 10.1332 12.5011H11.9999"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default GiftCard;
